import { render } from "./ContactUsView.vue?vue&type=template&id=08e5b890&scoped=true"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"

import "@/assets/css/app.a60e7e5f.css?vue&type=style&index=0&id=08e5b890&scoped=true&lang=css&external"
import "./ContactUsView.vue?vue&type=style&index=1&id=08e5b890&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e5b890"]])

export default __exports__